import React from 'react';

import { Box, Flex, Heading, Text, useMediaQuery, useQuery } from '@chakra-ui/react';
import Link from 'next/link';

import { CoverImage } from '@/components/sections/library';
import { ImageFragment, Library } from '@/graphql/generated';
import { dropHTMLTags } from '@/utils/drop-html-tags';
import { GeneralPath } from '@/utils/models';

type EbookCardProps = {
  cover: ImageFragment | undefined;
} & Pick<Library, 'title' | 'content' | 'slug'>;

export const EbookCard = ({ cover, content, title, slug }: Partial<EbookCardProps>) => {
  const [isBelow1010] = useMediaQuery(useQuery({ below: '1010px' }));

  const coverImage = cover;

  return (
    <Flex
      as={Link}
      href={`${GeneralPath.LIBRARY}/${slug}`}
      flexDir="column"
      maxW={{
        base: '190px',
        xs: '286px',
        sm: '190px',
        md: isBelow1010 ? '230px' : '286px',
      }}
      cursor="pointer"
    >
      <Box
        w={{
          base: '190px',
          xs: '286px',
        }}
        maxW="100%"
        mb={{
          base: 10,
          md: 12,
        }}
      >
        {coverImage && <CoverImage cover={coverImage} />}
      </Box>
      <Heading
        variant={{
          base: 'component-article-headline/xl',
          sm: 'component-article-headline/2xl',
          lg: 'component-article-headline/3xl',
        }}
        color="purple.500"
        mb={{
          base: 4,
          md: 6,
        }}
      >
        {dropHTMLTags(title || '')}
      </Heading>
      <Text
        color="purple.500"
        variant="text-md/lineHeight-6/font-normal"
        maxH="100px"
        sx={{
          display: '-webkit-box',
          overflow: 'hidden',
          WebkitLineClamp: '3',
          WebkitBoxOrient: 'vertical',
        }}
      >
        {dropHTMLTags(content || '')}
      </Text>
    </Flex>
  );
};
